/**
 * Address-form helpers.
 *
 * Sweden has no state or province in a postal address — a Swedish address is
 * street, postcode and "ort" (locality), nothing else. The checkout forms were
 * inherited from the Sharetribe template, which is written for the US, so they
 * asked every buyer for a "state" before they had even chosen a country.
 * See P25009-388 BR-2.
 */

/**
 * Countries where a state / province / region is NOT part of a normal postal
 * address. Deliberately a denylist rather than an allowlist: the set of
 * countries that DO use one (US, CA, AU, BR, IN, …) is long and the cost of
 * getting it wrong is asymmetric — hiding a field a buyer needs breaks their
 * delivery, while showing one they don't need is merely noise.
 */
export const COUNTRIES_WITHOUT_STATE = [
  'SE', // Sweden — the home market
  'NO',
  'DK',
  'FI',
  'IS',
  'DE',
  'NL',
  'BE',
  'AT',
  'CH',
  'FR',
  'PL',
  'CZ',
  'IE',
  'GB',
  'PT',
  'LU',
  'EE',
  'LV',
  'LT',
];

/**
 * Should the address form ask for a state / region?
 *
 * An empty country counts as "no" on purpose. The country select starts blank,
 * so a Swedish buyer working down the form would otherwise meet a "Stat" field
 * before reaching the country question — which is the bug reported in
 * P25009-388. The field reappears the moment a buyer picks somewhere that
 * genuinely uses one.
 *
 * @param {string} countryCode ISO 3166-1 alpha-2 code, or a falsy value when
 *   the buyer has not chosen a country yet.
 * @returns {boolean}
 */
export const usesStateField = countryCode => {
  if (!countryCode) return false;
  return !COUNTRIES_WITHOUT_STATE.includes(String(countryCode).toUpperCase());
};
